import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageFooterDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    MESSAGE_FOOTER_TYPOGRAPHY
} from "../../stylesheet";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        maxWidth: "100%",
        minWidth: 0
    }
});

export const useStyles = ({
    controlPaddings,
    controlHeights,
    isHasActions,
    typography,
    iconSizes,
    isPlain,
    spaces,
    align
}: MessageFooterDynamicStyleType) => {
    const styles = {
        container: {
            minHeight: isHasActions ? controlHeights.small : typography[MESSAGE_FOOTER_TYPOGRAPHY].lineHeight,
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        actions: {
            marginStart: (iconSizes.small - controlHeights.small) / 2
        } as Mutable<ViewStyle>
    };

    if(!isPlain) {
        styles.container[align === "end" ? "paddingStart" : "paddingEnd"] = controlPaddings.small;
    }

    return styles;
};
export default stylesheet;
